var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:('fill:'+ _vm.s),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.w,"height":_vm.h,"viewBox":_vm.v}},[_c('path',{attrs:{"d":_vm.d}})])}
var staticRenderFns = []

export { render, staticRenderFns }